module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-01-Scale.4c8527ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-01-Scale.jpg
// module id = 944
// module chunks = 37